import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Breadcrumbs from './Breadcrumbs';
import CallbackButton from './CallbackButton';
import useCallbackUri from './hooks/useCallbackUri';

type CrumbProps = {
  name: string;
  path: string;
};

const Subheader = ({
  crumbs,
  integrationName,
}: {
  crumbs: CrumbProps[];
  integrationName: string;
}) => {
  const { t } = useTranslation();

  const callbackUri = useLocation().pathname.split('callback_uri=')[1];
  useCallbackUri(callbackUri);

  return (
    <div
      className={classNames('w-100% h-56px flex flex-row items-center text-20', {
        'bg-white': callbackUri,
        'bg-gray-light': !callbackUri,
      })}
    >
      {callbackUri && <CallbackButton callbackUri={callbackUri} />}
      <Breadcrumbs crumbs={crumbs} integrationName={integrationName} translate={t} />
    </div>
  );
};

export default Subheader;
